<template>
  <div v-if="loading" class="stat-grid stat-grid--loading">
    <div v-for="n in 6" :key="n" class="stat-card stat-card--skeleton">
      <el-skeleton animated>
        <template #template>
          <div class="stat-skeleton">
            <el-skeleton-item variant="circle" class="stat-skeleton__icon" />
            <div class="stat-skeleton__text">
              <el-skeleton-item variant="h1" class="stat-skeleton__num" />
              <el-skeleton-item variant="text" class="stat-skeleton__label" />
            </div>
          </div>
        </template>
      </el-skeleton>
    </div>
  </div>
  <div v-else class="stat-grid">
    <div
      class="stat-card"
      v-for="(item, index) in displayItems"
      :key="item.key"
      @click="toMenu(item.key)"
    >
      <div class="stat-card__icon" :class="`stat-card__icon--${index % 6}`">
        <img :src="item.imgUrl" alt="" />
      </div>
      <div class="stat-card__body">
        <div class="stat-card__num">{{ item.num ?? 0 }}</div>
        <div class="stat-card__label">{{ item.title }}</div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";
import { useRouter } from "vue-router";
import { usePageI18n } from "@/composables/usePageI18n.js";
import { localizeStatItems } from "@/utils/homeDashboardI18n.js";

const props = defineProps({
  items: { type: Array, default: () => [] },
  loading: { type: Boolean, default: false },
})

const router = useRouter();

const menuMap = {
  'baoyangMun': '/equipment',
  'captainMun': '/captain',
  'jinnegMun': '/improve',
  'jishouMun': '/Machinist',
  'sheibeiMun': '/equipment/device',
  'teshuMun': '/task',
  'userMun': '/system'
}

const applyLabels = () => {}
const { locale } = usePageI18n(applyLabels)

const displayItems = computed(() => {
  locale.value
  return localizeStatItems(props.items)
})

const toMenu = (key) => {
  const path = menuMap[key]
  if (!path) return
  router.push({ path });
}
</script>

<style lang="less" scoped>
.stat-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
  gap: 12px;
}

.stat-card {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 16px 18px;
  background: var(--admin-card-bg);
  border: 1px solid var(--admin-card-border);
  border-radius: var(--admin-radius-md);
  box-shadow: var(--admin-card-shadow);
  cursor: pointer;
  transition: box-shadow 0.15s, transform 0.15s;

  &:hover {
    box-shadow: 0 4px 20px rgba(15, 23, 42, 0.08);
    transform: translateY(-1px);
  }

  &--skeleton {
    cursor: default;
    &:hover {
      transform: none;
      box-shadow: var(--admin-card-shadow);
    }
  }
}

.stat-skeleton {
  display: flex;
  align-items: center;
  gap: 14px;
  width: 100%;
}

.stat-skeleton__icon {
  width: 44px;
  height: 44px;
  flex-shrink: 0;
}

.stat-skeleton__text {
  flex: 1;
}

.stat-skeleton__num {
  width: 48px;
  height: 28px;
  margin-bottom: 8px;
}

.stat-skeleton__label {
  width: 72px;
}

.stat-card__icon {
  width: 44px;
  height: 44px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  img {
    width: 28px;
    height: 28px;
    object-fit: contain;
  }

  &--0 { background: #eff6ff; }
  &--1 { background: #f0fdf4; }
  &--2 { background: #fef3c7; }
  &--3 { background: #fce7f3; }
  &--4 { background: #ede9fe; }
  &--5 { background: #ecfdf5; }
}

.stat-card__num {
  font-size: 26px;
  font-weight: 700;
  color: var(--admin-text-primary);
  line-height: 1.2;
}

.stat-card__label {
  font-size: 13px;
  color: var(--admin-text-secondary);
  margin-top: 2px;
}
</style>
